import clickOutside from "../directives/click-ouside.js";
import dataTypes from "../directives/data-types.js";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install(Vue) {
    Vue.directive("click-outside", clickOutside);
    Vue.directive("dataTypes", dataTypes);
  }
};

export default GlobalDirectives;
